export default __webpack_public_path__ + "static/media/send.43674f75.svg";